import React, { useState } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
import NewReachTextEditor from "./NewReachTextEditor";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// Utility function to generate a 16-character unique ID
const generateUniqueId = () =>
  Math.random().toString(36).substring(2, 18) + Date.now().toString(36);

const AddMegaStaticPage = () => {
  const [pageType, setPageType] = useState("static_page"); // Default to 'Static Pages'
  const [serialNumber, setSerialNumber] = useState(""); // For serial number
  const [title, setTitle] = useState("");
  const [components, setComponents] = useState([]);
  const [sectionTitle, setSectionTitle] = useState("");

  const handleAddComponent = (type) => {
    setComponents((prev) => [
      ...prev,
      {
        id: generateUniqueId(), // Assign unique ID
        type,
        sectionTitle: "",
        value:
          type === "description"
            ? {
                title: "",
                thumbnail: "",
                content: "",
              }
            : type === "card"
            ? {
                media: [], // Array for media links
                title: "",
                date: "",
                description: "",
                externalLink: "",
              }
            : type === "gallery"
            ? [] // Initialize value for gallery
            : type === "cardGallery"
            ? [
                {
                  id: generateUniqueId(),
                  title: "",
                  date: "",
                  description: "",
                  media: [],
                  externalLink: "",
                },
              ]
            : null,
      },
    ]);
  };
  // Function to update section title dynamically
  const handleSectionTitleChange = (id, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id ? { ...comp, sectionTitle: value } : comp
      )
    );
  };
  const handleRemoveComponent = (id) => {
    setComponents((prev) => prev.filter((comp) => comp.id !== id));
  };

  const handleDescriptionChange = (id, field, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? { ...comp, value: { ...comp.value, [field]: value } }
          : comp
      )
    );
  };

  const handleCardMediaChange = (id, index, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? {
              ...comp,
              value: {
                ...comp.value,
                media: comp.value.media.map((item, idx) =>
                  idx === index ? value : item
                ),
              },
            }
          : comp
      )
    );
  };

  const handleCardAddMediaField = (id) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? {
              ...comp,
              value: { ...comp.value, media: [...comp.value.media, ""] },
            }
          : comp
      )
    );
  };

  const handleCardRemoveMediaField = (id, index) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? {
              ...comp,
              value: {
                ...comp.value,
                media: comp.value.media.filter((_, idx) => idx !== index),
              },
            }
          : comp
      )
    );
  };

  const handleCardChange = (id, field, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? { ...comp, value: { ...comp.value, [field]: value } }
          : comp
      )
    );
  };
  const handleCardDateChange = (id, field, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? { ...comp, value: { ...comp.value, [field]: value } }
          : comp
      )
    );
  };

  const handleGalleryChange = (id, index, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? {
              ...comp,
              value: comp.value.map((item, idx) =>
                idx === index ? value : item
              ),
            }
          : comp
      )
    );
  };

  const handleGalleryAddField = (id) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id ? { ...comp, value: [...comp.value, ""] } : comp
      )
    );
  };

  const handleGalleryRemoveField = (id, index) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? { ...comp, value: comp.value.filter((_, idx) => idx !== index) }
          : comp
      )
    );
  };

  // card gallery section functionality here
  const handleCardGalleryAddMediaField = (compId, cardId) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === compId
          ? {
              ...comp,
              value: comp.value.map((card) =>
                card.id === cardId
                  ? { ...card, media: [...card.media, ""] }
                  : card
              ),
            }
          : comp
      )
    );
  };

  const handleCardGalleryMediaChange = (compId, cardId, index, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === compId
          ? {
              ...comp,
              value: comp.value.map((card) =>
                card.id === cardId
                  ? {
                      ...card,
                      media: card.media.map((item, idx) =>
                        idx === index ? value : item
                      ),
                    }
                  : card
              ),
            }
          : comp
      )
    );
  };

  const handleCardGalleryRemoveMediaField = (compId, cardId, index) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === compId
          ? {
              ...comp,
              value: comp.value.map((card) =>
                card.id === cardId
                  ? {
                      ...card,
                      media: card.media.filter((_, idx) => idx !== index),
                    }
                  : card
              ),
            }
          : comp
      )
    );
  };
  const handleCardGalleryAddCard = (id) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? {
              ...comp,
              value: [
                ...comp.value,
                {
                  id: generateUniqueId(),
                  title: "",
                  description: "",
                  media: [],
                  externalLink: "",
                },
              ],
            }
          : comp
      )
    );
  };

  const handleCardGalleryRemoveCard = (compId, cardId) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === compId
          ? {
              ...comp,
              value: comp.value.filter((card) => card.id !== cardId),
            }
          : comp
      )
    );
  };

  const handleCardGalleryChange = (compId, cardId, field, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === compId
          ? {
              ...comp,
              value: comp.value.map((card) =>
                card.id === cardId ? { ...card, [field]: value } : card
              ),
            }
          : comp
      )
    );
  };
  const handleCardGalleryDateChange = (compId, cardId, field, value) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === compId
          ? {
              ...comp,
              value: comp.value.map((card) =>
                card.id === cardId ? { ...card, [field]: value } : card
              ),
            }
          : comp
      )
    );
  };
  const onDragEnd = (result) => {
    const { destination, source } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const newComponents = Array.from(components);
    const [removed] = newComponents.splice(source.index, 1);
    newComponents.splice(destination.index, 0, removed);

    setComponents(newComponents);
  };
  const handleSubmit = async () => {
    const payload = {
      type: pageType,
      sl_no: serialNumber,
      title,
      components,
      status: 1,
      is_deleted: 0,
    };
    try {
      await scAxiosAdmin.post("/static_services_pages", payload);
      toast.success("Page successfully submitted!");
    } catch (error) {
      console.error("Error submitting page:", error);
      toast.error("There was an error submitting the page.");
    }
  };

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="col-lg-12">
                <div className="card m-b-20">
                  <div className="card-body">
                    <h1>Page Builder</h1>
                    <div>
                      <label>Page Type:</label>
                      <select
                        className="form-control mb-3"
                        value={pageType}
                        onChange={(e) => setPageType(e.target.value)}
                      >
                        <option value="static_page">Static Pages</option>
                        <option value="services">Services</option>
                      </select>
                    </div>
                    <div>
                      <label>Serial Number:</label>
                      <input
                        type="number"
                        className="form-control mb-3"
                        value={serialNumber}
                        onChange={(e) => setSerialNumber(e.target.value)}
                      />
                    </div>
                    <div>
                      <label>Page Title:</label>
                      <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="form-control mb-3"
                      />
                    </div>
                    <div className="d-flex justify-content-start gap-3">
                      <button
                        onClick={() => handleAddComponent("description")}
                        className="btn btn-primary mr-2"
                      >
                        Add Description
                      </button>
                      <button
                        onClick={() => handleAddComponent("card")}
                        className="btn btn-primary mr-2"
                      >
                        Add Card
                      </button>
                      <button
                        onClick={() => handleAddComponent("gallery")}
                        className="btn btn-primary mr-2"
                      >
                        Add Gallery
                      </button>
                      <button
                        onClick={() => handleAddComponent("cardGallery")}
                        className="btn btn-primary"
                      >
                        Add Card Gallery
                      </button>
                    </div>

                    <DragDropContext onDragEnd={onDragEnd}>
                      <Droppable droppableId="components">
                        {(provided) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {components.map((comp, index) => (
                              <Draggable
                                key={comp.id}
                                draggableId={comp.id}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div key={comp.id} className="mb-4">
                                      <h3>{`Component ${index + 1}: ${
                                        comp.type
                                      }`}</h3>
                                      <label>Section Title</label>
                                      <input
                                        type="text"
                                        className="form-control mb-2"
                                        value={comp.sectionTitle || ""}
                                        onChange={(e) =>
                                          handleSectionTitleChange(
                                            comp.id,
                                            e.target.value
                                          )
                                        }
                                      />
                                      {comp.type === "description" && (
                                        <div>
                                          <label>Description Title</label>
                                          <input
                                            type="text"
                                            className="form-control mb-2"
                                            value={comp.value.title}
                                            onChange={(e) =>
                                              handleDescriptionChange(
                                                comp.id,
                                                "title",
                                                e.target.value
                                              )
                                            }
                                          />
                                          <label>Thumbnail Description</label>
                                          <input
                                            type="text"
                                            className="form-control mb-2"
                                            value={comp.value.thumbnail}
                                            onChange={(e) =>
                                              handleDescriptionChange(
                                                comp.id,
                                                "thumbnail",
                                                e.target.value
                                              )
                                            }
                                          />
                                          <label>Content</label>
                                          <NewReachTextEditor
                                            id={`description-${comp.id}`}
                                            value={comp.value.content}
                                            onChange={(id, value) =>
                                              handleDescriptionChange(
                                                comp.id,
                                                "content",
                                                value
                                              )
                                            }
                                          />
                                        </div>
                                      )}
                                      {comp.type === "card" && (
                                        <div>
                                          <h4>Card</h4>
                                          <label>Card Title</label>
                                          <input
                                            type="text"
                                            className="form-control mb-2"
                                            value={comp.value.title}
                                            onChange={(e) =>
                                              handleCardChange(
                                                comp.id,
                                                "title",
                                                e.target.value
                                              )
                                            }
                                          />{" "}
                                          <label>Card Date</label>
                                          <input
                                            type="date"
                                            className="form-control mb-2"
                                            value={comp.value.date}
                                            onChange={(e) =>
                                              handleCardDateChange(
                                                comp.id,
                                                "date",
                                                e.target.value
                                              )
                                            }
                                          />{" "}
                                          <br />
                                          <button
                                            onClick={() =>
                                              handleCardAddMediaField(comp.id)
                                            }
                                            className="btn btn-secondary mb-3"
                                          >
                                            Add Media Field
                                          </button>
                                          {comp.value.media.map((link, idx) => (
                                            <div
                                              key={idx}
                                              className="d-flex align-items-center mb-2"
                                            >
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={link}
                                                onChange={(e) =>
                                                  handleCardMediaChange(
                                                    comp.id,
                                                    idx,
                                                    e.target.value
                                                  )
                                                }
                                                placeholder={`Media ${idx + 1}`}
                                              />
                                              <button
                                                onClick={() =>
                                                  handleCardRemoveMediaField(
                                                    comp.id,
                                                    idx
                                                  )
                                                }
                                                className="btn btn-danger ml-2"
                                              >
                                                Remove
                                              </button>
                                            </div>
                                          ))}{" "}
                                          <br />
                                          <label>Card Description</label>
                                          <NewReachTextEditor
                                            id={`card-description-${comp.id}`}
                                            value={comp.value.description}
                                            onChange={(id, value) =>
                                              handleCardChange(
                                                comp.id,
                                                "description",
                                                value
                                              )
                                            }
                                          />
                                          <label>External Link</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={comp.value.externalLink}
                                            onChange={(e) =>
                                              handleCardChange(
                                                comp.id,
                                                "externalLink",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      )}
                                      {comp.type === "gallery" && (
                                        <div>
                                          <button
                                            onClick={() =>
                                              handleGalleryAddField(comp.id)
                                            }
                                            className="btn btn-secondary mb-3"
                                          >
                                            Add Media Field
                                          </button>
                                          {comp.value.map((link, idx) => (
                                            <div
                                              key={idx}
                                              className="d-flex align-items-center mb-2"
                                            >
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={link}
                                                onChange={(e) =>
                                                  handleGalleryChange(
                                                    comp.id,
                                                    idx,
                                                    e.target.value
                                                  )
                                                }
                                                placeholder={`Media ${idx + 1}`}
                                              />
                                              <button
                                                onClick={() =>
                                                  handleGalleryRemoveField(
                                                    comp.id,
                                                    idx
                                                  )
                                                }
                                                className="btn btn-danger ml-2"
                                              >
                                                Remove
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                      {comp.type === "cardGallery" && (
                                        <div>
                                          <h4>Card Gallery</h4>
                                          <div className="row row-cols-1 row-cols-md-3">
                                            {comp.value.map((card, cardIdx) => (
                                              <div
                                                key={card.id}
                                                className="border p-3 mb-3 rounded"
                                              >
                                                <label>Card Title</label>
                                                <input
                                                  type="text"
                                                  className="form-control mb-2"
                                                  value={card.title}
                                                  onChange={(e) =>
                                                    handleCardGalleryChange(
                                                      comp.id,
                                                      card.id,
                                                      "title",
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                                <label>Card Date</label>
                                                <input
                                                  type="date"
                                                  className="form-control mb-2"
                                                  // value={card.title}
                                                  onChange={(e) =>
                                                    handleCardGalleryDateChange(
                                                      comp.id,
                                                      card.id,
                                                      "date",
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                                <label>Card Media</label>
                                                <br />
                                                <button
                                                  onClick={() =>
                                                    handleCardGalleryAddMediaField(
                                                      comp.id,
                                                      card.id
                                                    )
                                                  }
                                                  className="btn btn-secondary mb-3"
                                                >
                                                  Add Media Field
                                                </button>
                                                {card.media.map(
                                                  (media, idx) => (
                                                    <div
                                                      key={idx}
                                                      className="d-flex align-items-center mb-2"
                                                    >
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={media}
                                                        onChange={(e) =>
                                                          handleCardGalleryMediaChange(
                                                            comp.id,
                                                            card.id,
                                                            idx,
                                                            e.target.value
                                                          )
                                                        }
                                                        placeholder={`Media ${
                                                          idx + 1
                                                        }`}
                                                      />
                                                      <button
                                                        onClick={() =>
                                                          handleCardGalleryRemoveMediaField(
                                                            comp.id,
                                                            card.id,
                                                            idx
                                                          )
                                                        }
                                                        className="btn btn-danger ml-2"
                                                      >
                                                        Remove
                                                      </button>
                                                    </div>
                                                  )
                                                )}

                                                <br />
                                                {/* <button
                            onClick={() =>
                              handleCardGalleryRemoveCard(
                                comp.id,
                                card.id
                              )
                            }
                            className="btn btn-danger mt-2"
                          >
                            Remove Card
                          </button> */}
                                                <label>Card Description</label>
                                                <NewReachTextEditor
                                                  id={`card-gallery-description-${comp.id}-${card.id}`}
                                                  value={card.description}
                                                  onChange={(id, value) =>
                                                    handleCardGalleryChange(
                                                      comp.id,
                                                      card.id,
                                                      "description",
                                                      value
                                                    )
                                                  }
                                                />
                                                <label>Media Links</label>
                                                {card.media.map(
                                                  (media, mediaIdx) => (
                                                    <div
                                                      key={mediaIdx}
                                                      className="d-flex align-items-center mb-2"
                                                    >
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={media}
                                                        onChange={(e) =>
                                                          handleCardGalleryChange(
                                                            comp.id,
                                                            card.id,
                                                            "media",
                                                            [
                                                              ...card.media.slice(
                                                                0,
                                                                mediaIdx
                                                              ),
                                                              e.target.value,
                                                              ...card.media.slice(
                                                                mediaIdx + 1
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  )
                                                )}
                                                <label>External Link</label>
                                                <input
                                                  type="text"
                                                  className="form-control mb-2"
                                                  value={card.externalLink}
                                                  onChange={(e) =>
                                                    handleCardGalleryChange(
                                                      comp.id,
                                                      card.id,
                                                      "externalLink",
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                                <button
                                                  onClick={() =>
                                                    handleCardGalleryRemoveCard(
                                                      comp.id,
                                                      card.id
                                                    )
                                                  }
                                                  className="btn btn-danger"
                                                >
                                                  Remove Card
                                                </button>
                                              </div>
                                            ))}
                                          </div>

                                          <button
                                            onClick={() =>
                                              handleCardGalleryAddCard(comp.id)
                                            }
                                            className="btn btn-primary mt-2"
                                          >
                                            Add Another Card
                                          </button>
                                        </div>
                                      )}
                                      <button
                                        onClick={() =>
                                          handleRemoveComponent(comp.id)
                                        }
                                        className="btn btn-danger mt-2"
                                      >
                                        Remove Component
                                      </button>
                                      <hr className="w-50 mx-auto" />
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                    <button onClick={handleSubmit} className="btn btn-success">
                      Submit Page
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default AddMegaStaticPage;



// WEBPACK FOOTER //
// ./src/component/admin/AddMegaStaticPage.js